<template>
  <div class="about-page">
    <my-header></my-header>
    <!-- 英雄区：标题、标语、图片 -->
    <div class="hero-section">
      <div class="hero-image">
        <img
            src="../assets/aboutHaibao.jpg"
            :alt="$t('about.imgAlt')"
        class="parallax-image"
        >
        <div class="overlay"></div>
      </div>
      <div class="hero-content">
        <h1 class="title">{{ $t('about.title') }}</h1>  <!-- 页面标题国际化 -->
        <h3 class="slogan">{{ $t('about.biaoyu') }}</h3>  <!-- 标语国际化 -->
      </div>
    </div>

    <!-- 统计区：员工、专利、成立年份 -->
    <div class="company-info container">
      <div class="section-title">
        <h2 class="animate-on-scroll">{{ $t('about.sectionTitle') }}</h2>  <!-- 统计区标题国际化 -->
        <div class="underline"></div>
      </div>

      <div class="info-grid">
        <div class="stats-card animate-on-scroll" :style="{animationDelay: '0.1s'}">
          <div class="icon"><i class="fa fa-users"></i></div>
          <h3 class="stat">40+</h3>
          <p class="stat-desc">{{ $t('about.stats.professionalStaff') }}</p>
        </div>

        <div class="stats-card animate-on-scroll" :style="{animationDelay: '0.2s'}">
          <div class="icon"><i class="fas fa-lightbulb"></i></div>
          <h3 class="stat">90+</h3>
          <p class="stat-desc">{{ $t('about.stats.patents') }}</p>
        </div>

        <div class="stats-card animate-on-scroll" :style="{animationDelay: '0.3s'}">
          <div class="icon"><i class="fa fa-calendar"></i></div>
          <h3 class="stat">2018</h3>
          <p class="stat-desc">{{ $t('about.stats.foundedYear') }}</p>
        </div>
      </div>
    </div>

    <!-- 详情区：公司简介、产品优势、服务理念 -->
    <div class="description-section container">
      <div class="content-block animate-on-scroll">
        <h3 class="block-title">{{ $t('about.blocks.companyOverview') }}</h3>  <!-- 区块标题国际化 -->
        <p>{{ $t('about.des_a') }}</p>  <!-- 公司简介详情国际化 -->
      </div>

      <div class="content-block animate-on-scroll">
        <h3 class="block-title">{{ $t('about.blocks.productAdvantages') }}</h3>  <!-- 区块标题国际化 -->
        <p>{{ $t('about.des_b') }}</p>  <!-- 产品优势详情国际化 -->
      </div>

      <div class="content-block animate-on-scroll">
        <h3 class="block-title">{{ $t('about.blocks.serviceIdea') }}</h3>  <!-- 区块标题国际化 -->
        <p>{{ $t('about.des_c') }}</p>  <!-- 服务理念详情国际化 -->
      </div>
    </div>

    <my-foot></my-foot>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import MyFoot from "@/components/MyFoot";

export default {
  name: "AboutUs",
  data() {
    return {
      // 移除硬编码文本：所有文本通过i18n动态获取，无需在data中定义
    };
  },
  components: {
    MyHeader,
    MyFoot
  },
  mounted() {
    this.setupScrollAnimations(); // 滚动动画初始化（保持原逻辑）
  },
  methods: {
    setupScrollAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible'); // 滚动到视图时添加"visible"类
          }
        });
      }, { threshold: 0.1 });

      // 监听所有需要滚动动画的元素
      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    }
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 全局变量 */
:root {
  --primary-color: #0066cc;
  --secondary-color: #ff9900;
  --text-color: #333333;
  --light-bg: #f8f9fa;
  --dark-bg: #2c3e50;
  --transition: all 0.3s ease;
}

.about-page {
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
}

/* 英雄区域 */
.hero-section {
  height: 500px;
  position: relative;
  overflow: hidden;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.parallax-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translateZ(-10px) scale(2);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.hero-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  width: 80%;
}

.title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s forwards 0.3s;
}

.slogan {
  font-size: clamp(1.2rem, 3vw, 1.8rem);
  font-weight: 400;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s forwards 0.6s;
}

/* 公司信息区域 */
.company-info {
  padding: 80px 0;
  background-color: var(--light-bg);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  color: var(--primary-color);
  margin-bottom: 10px;
  opacity: 0;
  transform: translateY(20px);
  transition: var(--transition);
}

.section-title h2.visible {
  opacity: 1;
  transform: translateY(0);
}

.underline {
  width: 80px;
  height: 3px;
  background-color: var(--secondary-color);
  margin: 0 auto;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.stats-card {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  text-align: center;
  opacity: 0;
  transform: translateY(20px);
  transition: var(--transition);
}

.stats-card.visible {
  opacity: 1;
  transform: translateY(0);
}

.stats-card .icon {
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.stats-card .stat {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: var(--dark-bg);
}

.stats-card .stat-desc {
  font-size: 1.1rem;
  color: #666;
}

/* 描述部分 */
.description-section {
  padding: 80px 0;
}

.content-block {
  margin-bottom: 50px;
  opacity: 0;
  transform: translateY(20px);
  transition: var(--transition);
}

.content-block.visible {
  opacity: 1;
  transform: translateY(0);
}

.block-title {
  font-size: 1.8rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.content-block p {
  text-indent: 2em;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 20px;
  color: var(--text-color);
}

/* 动画：渐入上移 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .hero-section {
    height: 400px;
  }

  .title {
    font-size: 2.5rem;
  }

  .slogan {
    font-size: 1.2rem;
  }

  .content-block p {
    font-size: 1rem;
  }
}
</style>
